<template>
  <div class="mobilebar-profile">
    <nav class="menu">
      <ul>
        <li v-for="(item, index) in sidebarList" :key="index" class="position-relative">
          <router-link :to="item.link" class="menu-link" active-class="active">
            <img :src="item.icon" />
            <span v-if="item.link === '/profile/basket' && cartCount > 0" class="mobile-badge"></span>
          </router-link>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
  import { useStore } from 'vuex';
  import { defineComponent, computed } from 'vue';
  import { useRouter } from 'vue-router';
  import { sidebarList } from '@/models/sidebar';

  export default defineComponent({
    name: 'MobileBar',
    setup() {
      const router = useRouter();
      const store = useStore();
      const cartCount = computed(() => store.state.user.cartItems);

      return {
        sidebarList,
        router,
        cartCount,
      };
    },
  });
</script>

<style lang="scss">
  @import '@/assets/styles/profile/mobilebar';

  .mobile-badge {
    position: absolute;
    top: 0;
    right: 0;

    width: 10px;
    height: 10px;

    background-color: #d44233;
    border: 2px solid white;
    border-radius: 50%;
  }
</style>
